import React, { useCallback } from 'react';
import './TextInput.css';

export default function TextInput({
    className,
    value,
    disabled = false,
    placeholder = '',
    onChange,
    label = null,
    valid = false,
    multiline = false,
    rows = 6,
    validationRegExp,
}) {
    const changeHandler = useCallback(
        e => {
            const valid = validationRegExp?.test(e.target.value) ?? true;
            if (onChange) onChange({ value: e.target.value, valid });
        },
        [onChange, validationRegExp]
    );

    return (
        <div className={`text-input ${className}`}>
            {label && <p className={'text-input__label'}>{label}</p>}
            {multiline ? (
                <textarea
                    className={`text-input__input ${
                        !valid && value && !disabled && 'text-input__input--invalid'
                    }`}
                    value={value}
                    disabled={disabled}
                    placeholder={placeholder}
                    onChange={changeHandler}
                    rows={rows}
                />
            ) : (
                <input
                    className={`text-input__input ${
                        !valid && value && !disabled && 'text-input__input--invalid'
                    }`}
                    value={value}
                    disabled={disabled}
                    placeholder={placeholder}
                    onChange={changeHandler}
                    multiple={true}
                />
            )}
        </div>
    );
}
